<template>
  <div class="hm-banner">
    <div class="banner" v-if="!isH5">
      <a-carousel
        effect="fade"
        dots-class="slick-dots slick-thumb"
        :afterChange="afterChange"
        :pauseOnFocus="false"
        :pauseOnHover="false"
        ref="carousel"
      >
        <div slot="customPaging" slot-scope="props">
          <div class="custom">
            <div class="color" v-if="bannerKey === props.i"></div>
          </div>
        </div>
        <div v-for="item in bannerPcList" :key="item.id">
          <!-- 背景图自动缩放居中使用backgroundImage并添加背景定位属性实现 -->
          <div class="banner_bg" :style="{backgroundImage:'url(' + item.surfacePlotUrl + ')'}"  @click="onClickBanner(item)">
            <!-- <div class="btn_box">
              <a-button
              class="wbtn"
              v-if="String(item.ifEnableLink) === '0'"
              @click="download()"
              >资料下载</a-button>
            </div> -->
          </div>
        </div>
      </a-carousel>
      <div class="apply-wrap">
        <HmTaxSaasApply title="申请免费体验华盟税纪云"/>
      </div>
    </div>
    <div class="banner_h5" v-else>
      <a-carousel
        effect="fade"
        dots-class="slick-dots slick-thumb"
        :afterChange="afterChange"
        :pauseOnFocus="false"
        :pauseOnHover="false"
        ref="carousel"
      >
        <div slot="customPaging" slot-scope="props">
          <div class="custom">
            <div class="color" v-if="bannerKey === props.i"></div>
          </div>
        </div>
        <div v-for="item in bannerPcList" :key="item.key">
          <!-- 背景图自动缩放居中使用backgroundImage并添加背景定位属性实现 -->
          <div class="banner_bg" :style="{backgroundImage:'url(' + item.surfacePlotUrl + ')'}" @click="onClickBanner(item)">
            <!-- <div class="btn_box">
              <a-button
              class="wbtn"
              v-if="item.key === 0"
              @click="download(item)"
              >资料下载</a-button>
            </div> -->
          </div>
        </div>
      </a-carousel>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { PostQueryOfficialBannerList } from '@/api/api'
import HmTaxSaasApply from '@/components/hm-taxsaas-apply'

export default {
  name: 'hmBanner',
  props: {},
  components: { HmTaxSaasApply },
  data () {
    return {
      percent: 0,
      bannerKey: 0,
      bannerList: [],
      screenWidth: null,
      bannerPcList: []
    }
  },
  computed: {
    ...mapGetters(['isH5'])
  },
  created () {
    this.afterChange(0)
    this.getBanner()
  },
  mounted () {
    this.screenWidth = window.innerWidth
    window.onresize = () => {
      return (() => {
        this.screenWidth = window.innerWidth
      })()
    }
  },
  watch: {
    percent (num) {
      if (num === 100) {
        this.$refs.carousel.next()
      }
    }
  },
  methods: {
    getBanner () {
      PostQueryOfficialBannerList({
        pageNum: 1,
        pageSize: 10,
        enableLocation: '1', // 启用位置 0无 1首页
        languages: '1', //  语种 0无 1中文 2英文 3日文
        terminal: this.isH5 ? '2' : '1' // 终端 1PC 2H5 3APP
      }).then(res => {
        if (!res.data) return
        this.bannerPcList = res.data[0].list
        console.log(this.bannerPcList, 'bannerPcList')
      })
    },
    afterChange (key) {
      clearInterval(this.interval)
      this.percent = 0
      this.bannerKey = key
      this.interval = setInterval(() => {
        if (this.percent < 100) {
          this.percent += 1
        }
      }, 50)
    },
    onClickBanner (item) {
      console.log('%c点击Banner', 'background-color: green;color: #fff;', item)
      const { ifEnableLink, floatingPlotUrl } = item
      // ifEnableLink是否跳转链接 0是 1否
      const hasLink = ifEnableLink === '0'
      if (!hasLink) return
      const outsideLink = floatingPlotUrl.includes('https://') || floatingPlotUrl.includes('http://')
      if (outsideLink) { // 外部链接
        window.open(floatingPlotUrl, '_blank')
      } else {
        this.$router.push({
          path: floatingPlotUrl
        })
      }
    }
  }
}
</script>
<style scoped lang='less'>
#hm-web {
  .banner {
    width: 100%;
    min-width: 1200PX;
    max-width: 2560PX;
    margin: 0 auto;
    height: 556PX;
    position: relative;
    /deep/.ant-carousel .slick-dots-bottom {
        bottom: 28PX;
    }
    .banner_bg {
      height: 556PX;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      cursor: pointer;
      .btn_box {
        width: 1200PX;
        margin: 0 auto;
        padding-top: 379PX;
        .wbtn {
          width: 148PX;
          height: 48PX;
          background-color: #3e77ff;
          border-radius: 6PX;
          color: #ffffff;
          font-size: 20PX;
          background-image: linear-gradient(111deg, #3E77FF 0%, #3BA7FC 100%, #68A4F2 100%);
        }
      }
    }
    .custom {
      width: 40PX;
      height: 3PX;
      margin-top: 5PX;
      background-color: #e2ebff;
      border-radius: 10PX;
      cursor: pointer;
      .color {
        height: 100%;
        background-color: #3e77ff;
        border-radius: 10PX;
        animation-name: move;
        animation-duration: 5s;
        -webkit-animation-duration: 5s;
        animation-iteration-count: 1;
        animation-timing-function: cubic-bezier(0,0,0,0);
      }
      @keyframes move {
        0%{
          width: 0;
        }
        100%{
          width: 100%;
        }
      }
      .nones {
        background-color: #fff;
      }
    }
  }
  .apply-wrap {
    position: absolute;
    top: 50%;
    // right: 50%;
    right: calc((100vw - 1200PX) / 2);
    display: flex;
    justify-content: flex-end;
    // min-width: 1200PX;
    transform: translate(0,-50%);
  }
  .banner_h5 {
    // width: 100%;
    max-width: 37.5rem;
    margin: 0 auto;
    height: 35rem;
    position: relative;
    /deep/.ant-carousel .slick-dots-bottom {
        bottom: 1.4rem;
    }
    .banner_bg {
      height: 35rem;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      .btn_box {
        width: 37.5rem;
        margin: 0 auto;
        padding: 0 3rem;
        padding-top: 22.6rem;
        .wbtn {
          width: 12rem;
          height: 4rem;
          background-color: #3e77ff;
          border-radius: .4rem;
          color: #ffffff;
          font-size: 1.6rem;
          background-image: linear-gradient(111deg, #3E77FF 0%, #3BA7FC 100%, #68A4F2 100%);
        }
      }
    }
    .custom {
      width: 2.8rem;
      height: .4rem;
      margin-top: -2rem;
      background-color: #e2ebff;
      border-radius: .2rem;
      cursor: pointer;
      .color {
        height: 100%;
        background-color: #3e77ff;
        border-radius: .2rem;
        animation-name: move;
        animation-duration: 5s;
        -webkit-animation-duration: 5s;
        animation-iteration-count: 1;
        animation-timing-function: cubic-bezier(0,0,0,0);
      }
      @keyframes move {
        0%{
          width: 0;
        }
        100%{
          width: 100%;
        }
      }
      .nones {
        background-color: #fff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/banner.vue